import React from 'react';
import Input from "../Input-new/Input";
import SelectFirm from "../SelectFirm/SelectFirm";
import PropTypes from "prop-types";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";

const AgentForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange, addNewItem, newFirm}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Agent' : 'Add Agent'}</div>
                {isFilter ? (
                    <Input theme={theme}
                           width={width}
                           valueType='text'
                           name='NAME'
                           label='Name'
                           value={data.NAME}
                           handleParentChange={handleParentChange}
                    />
                ) : (
                    <React.Fragment>
                        <Input theme={theme}
                               width={width}
                               valueType='text'
                               name='FIRST_NAME'
                               label='First Name'
                               value={data.FIRST_NAME}
                               required={!isFilter}
                               handleParentChange={handleParentChange}
                        />
                        <Input theme={theme}
                               width={width}
                               valueType='text'
                               name='LAST_NAME'
                               label='Last Name'
                               value={data.LAST_NAME}
                               required={!isFilter}
                               handleParentChange={handleParentChange}
                        />
                    </React.Fragment>
                )}
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='PHONE'
                       label='Work Phone'
                       value={data.PHONE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='CELL_PHONE'
                       label='Cell Phone'
                       value={data.CELL_PHONE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType={isFilter ? 'text' : 'email'}
                       name='EMAIL'
                       label='Email'
                       value={data.EMAIL}
                       handleParentChange={handleParentChange}
                />
                <SelectFirm theme={theme}
                            width={width}
                            value={data.FIRM}
                            valueKey='FIRM'
                            label='Firm'
                            data={data}
                            hasDrawer={!isFilter}
                            handleParentChange={handleParentDropdownChange}
                            addNewItem={addNewItem}
                            withAddNew={!isFilter}
                            newFirm={newFirm}
                />
                {isFilter && (
                    // Agents carry no address; this matches the state on the agent's firm.
                    <Dropdown theme={theme}
                              data={data}
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={data.STATE}
                              valueKey='STATE'
                              label='State'
                              handleParentChange={handleParentDropdownChange}
                    />
                )}
                {isFilter && (
                    // The markets the property filter offers, placed by the firm's ZIP.
                    <Dropdown dropdownType='multiple'
                              theme={theme}
                              data={data}
                              optionsType='market'
                              optionKey='code'
                              optionLabelKey='name'
                              value={data.MARKET}
                              valueKey='MARKET'
                              label='Market'
                              isFilter
                              handleParentChange={handleParentDropdownChange}
                    />
                )}
            </React.Fragment>
        ),
    ];
    return (
        <form className='form' onSubmit={handleSubmit}>
            {panes.length > 1 && (
                <div className='form-slider'>
                    {
                        panes.map((el, key) => (
                            <Control key={key} onClick={()=> handlePaneChange(key)}>
                                <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                            </Control>
                        ))
                    }
                </div>
            )}
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

AgentForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
    addNewItem: PropTypes.func,
    newFirm: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default AgentForm;